import { Action } from 'redux';

export interface IDocumentData {
  id: number;
  type: EDocumentType;
  file: string;
  file_name: string;
  privacy: EDocumentPrivacy;
  _destroy?: number;
  createdAt?: number;
}

export default interface IDocuments {
  dispatch: (v?: Action) => void;
  documents: IDocumentData[];
  editMode: boolean;
  formDirty: boolean;
  isInvestorZone?: boolean;
  isOwner?: boolean;
  hasInvestorAccess?: boolean | null;
}

export interface IDocumentsRowProps {
  editMode: boolean;
  document: IDocumentData;
  delete: (id: number) => void;
  dispatch?: (v?: Action) => void;
}

export type TDocuments = {
  showedAllUserDocs: boolean;
  showedAllInvestorDocs: boolean;
  data: IDocumentData[];
  userDocs: IDocumentData[];
  investorDocs: IDocumentData[];
  whitepaper: IDocumentData | any;
  uploadUserDocument: boolean;
  uploadWhitepaper: boolean;
  uploadInvestorDocument: boolean;
  prevDocuments: IDocumentData[];
};

export enum EDocumentType {
  other = 'other',
  whitepaper = 'whitepaper',
}

export enum EDocumentPrivacy {
  public = 'public',
  user = 'user',
  investor = 'investor',
}

